<template>
  <div class="selected">
    <h2>服贸会涉嫌知识产权侵权行为线上投诉须知</h2>
    <ol>
      <!-- <li>
        <h3>
          <strong>第一条</strong>为维护展会秩序，加强展会知识产权保护，根据<a
            href="https://www.ciftis.org/cn/attachDir/2020/08/2020080518311837664.docx"
            >《展会知识产权保护办法》</a
          >和<a
            href="https://www.ciftis.org/cn/attachDir/2020/08/2020080518293810563.docx"
            >《北京市展会知识产权保护办法》</a
          >，制定本投诉处理程序。
        </h3>
      </li> -->
      <li>
        <h3>
          <strong>一、</strong
          >服贸会举办期间，对涉嫌侵犯知识产权的行为，投诉人可以向知识产权保护办公室进行投诉，也可以通过服贸会官网设置的知识产权侵权纠纷投诉通道进行线上投诉。
        </h3>
      </li>
      <li>
        <h3><strong>二、</strong>投诉人通过线上投诉的，应当提交以下材料：</h3>
        <ol>
          <li></li>
          <li>
            （一）<a
              href="https://www.ciftis.org//cn/attachDir/2020/08/2020080518331583990.docx"
              >《展会知识产权投诉书》</a
            >；
          </li>
          <li>
            （二）投诉人的身份证明。自然人应当提供身份证件，法人应当提供主体资格证明；
          </li>
          <li>
            （三）授权委托证明。委托代理人的，应当提供授权委托证明和代理人的身份证明；
          </li>
          <li>
            （四）被投诉人基本情况资料；
          </li>
          <li>
            （五）知识产权证明。具体包括专利证书授权公告文本和专利登记簿；商标注册证书；著作权登记证书或者能够证明著作权的法律文件。知识产权发生变更、转让、许可等事项，还应当提交相关法律文件；
          </li>
          <li>
            （六）侵权证明。具体包括涉嫌侵权参展项目的名称、涉嫌侵权产品的宣传资料、照片、实物等。
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>三、</strong
          >涉及实用新型或者外观设计专利的，知识产权保护办公室可以要求投诉人出具由国务院专利行政部门做出的专利权评价报告，作为处理投诉的依据。
        </h3>
      </li>
      <li>
        <h3>
          <strong>四、</strong
          >涉及实用新型或者外观设计专利的，展会知识产权保护办公室可以要求投诉人出具由国务院专利行政部门作出的专利权评价报告，作为处理投诉的依据。
        </h3>
        <ol>
          <li>
            （一）投诉人已经向人民法院提起专利权、商标权或者著作权侵权诉讼的；
          </li>
          <li>
            （二）投诉人的专利权正处于无效宣告请求程序中的。
          </li>
          <li>
            （三）投诉人的专利权，商标权或者著作权存在权属纠纷，正处于人民法院的审理或者有关行政机关的调解程序中的。
          </li>
          <li>
            （四）投诉人的专利权已经终止或者无效，或者商标权已经被撤销，或者著作权已经超过保护期的。
          </li>
        </ol>
      </li>
      <li>
        <h3>
          <strong>五、</strong>
          投诉人提交的身份证明、知识产权权属证明等材料是在中国领域外形成的，应当经所在国公证机关予以证明，并经中国驻该国使领馆予以认证，或者履行中国与该所在国订立的有关条约中规定的证明手续；在中国香港、澳门、台湾地区形成的，应当履行相关的证明手续。
          <p>
            投诉人应当保证其提交的材料真实、合法、有效。材料是外文的，应当附中文译本。
          </p>
        </h3>
      </li>
      <li>
        <h3>
          <strong>六、</strong
          >投诉人撤诉的，可向知识产权保护办公室或知识产权侵权纠纷线上投诉通道提交撤诉申请，知识产权保护办公室审核通过后确认撤诉。
        </h3>
      </li>
      <li>
        <h3>
          <strong>七、</strong>其它处理程序参照<a
            href="https://www.ciftis.org/cn/attachDir/2020/08/2020080518335938536.jpg"
            target="blank"
            >《展会知识产权投诉处理程序》</a
          >执行。
        </h3>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'TextRule',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
h2 {
  margin: 0 0 25px;
  padding: 0 0 25px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  line-height: 32px;
}
ol,
h3 {
  color: #333;
  font-size: 14px;
  line-height: 26px;

  a {
    color: #fe8c01;
  }

  h3 {
    position: relative;
    padding: 0 0 0 50px;

    strong {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  li {
    margin: 0 0 19px;
    li {
      margin: 0;
      padding: 0 0 0 50px;

      li {
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>
